import { Component, Convention } from '../../../concepts/objects';
import { Matrix } from '../../../platform/geom/Matrix';
import { Point } from '../../../platform/geom/Point';
import { Rect } from '../../../platform/geom/Rect';
import { GuideLine, PotentialInteraction } from '../../canvas/entities/Physical';
import { Frame } from './Frame';

export interface FrameAddon extends Component {

    readonly parentFrame?: Frame;
    readonly layer?: 'bottom' | 'top';

    layoutCells?(mt: Matrix): Rect[];

    queryGuides?(): GuideLine[];

    test?(pt: Point): boolean;
    testInteraction?({ type, mpt }: PotentialInteraction): [boolean, string];
}

export const FrameAddon = new Convention<FrameAddon>('FrameAddon');
